import React from 'react';
import { Link } from 'react-router-dom';
// 'BarChart' has been removed from this line to fix the warning
import { BookOpen, Users, Code } from 'lucide-react'; 

const GuideSection = ({ icon, title, children }) => (
    <div className="glass-card p-8 rounded-2xl mb-8">
        <div className="flex items-center text-cyan-400 mb-4">
            {icon}
            <h2 className="ml-4 text-3xl font-bold text-white">{title}</h2>
        </div>
        <div className="text-gray-300 leading-relaxed space-y-4">
            {children}
        </div>
    </div>
);

export default function ResearchingProjectsPage() {
    return (
        <div className="space-y-8">
            <div className="text-center">
                <h1 className="text-4xl md:text-5xl font-black mb-4 bg-gradient-to-r from-cyan-400 to-purple-400 bg-clip-text text-transparent">
                    A Guide to Researching Crypto Projects
                </h1>
                <p className="text-lg text-gray-300 max-w-3xl mx-auto">
                    Doing your own research (DYOR) is the most critical skill in crypto. Here’s a breakdown of what to look for.
                </p>
            </div>

            <GuideSection icon={<BookOpen size={28}/>} title="1. Read the Whitepaper">
                <p>The whitepaper is the foundational document of a project. It should clearly explain:</p>
                <ul className="list-disc list-inside space-y-2 pl-4">
                    <li><strong>The Problem:</strong> What real-world problem is the project trying to solve? Is it a genuine issue?</li>
                    <li><strong>The Solution:</strong> How does the project's technology solve this problem in a unique or superior way?</li>
                    <li><strong>Tokenomics:</strong> What is the purpose of the project's token (utility, governance, etc.)? How is it distributed (e.g., to the team, to the public)? What is the total supply and is it inflationary or deflationary?</li>
                    <li><strong>Roadmap:</strong> What are the project's future development plans and milestones? Are they realistic?</li>
                </ul>
            </GuideSection>

            <GuideSection icon={<Users size={28}/>} title="2. Investigate the Team">
                <p>A strong, transparent team is a good indicator of a project's legitimacy. Look for:</p>
                 <ul className="list-disc list-inside space-y-2 pl-4">
                    <li><strong>Public Profiles:</strong> Are the team members' identities known? Do they have professional profiles on platforms like LinkedIn or GitHub? Be wary of anonymous teams.</li>
                    <li><strong>Experience:</strong> Does the team have relevant experience in blockchain, software development, business, or finance?</li>
                    <li><strong>Communication:</strong> Is the team active and engaged with the community on platforms like Twitter, Discord, or Telegram? Do they provide regular updates?</li>
                </ul>
            </GuideSection>

            <GuideSection icon={<Code size={28}/>} title="3. Review the Technology">
                <p>You don't need to be a developer to get a sense of a project's technology.</p>
                 <ul className="list-disc list-inside space-y-2 pl-4">
                    <li><strong>GitHub Activity:</strong> Is the project's code open-source? Look at their GitHub repository for recent and consistent activity. A dead repository is a major red flag.</li>
                    <li><strong>Use Case:</strong> Does the technology have a clear and practical use case? Does the world actually need this product?</li>
                    <li><strong>Smart Contract Audit:</strong> Has the project's smart contract been audited by a reputable third-party security firm like CertiK, Consensys Diligence, or Trail of Bits? The audit report should be publicly available.</li>
                </ul>
            </GuideSection>

            <div className="text-center pt-6">
                <Link to="/learn" className="text-cyan-400 hover:text-cyan-300 font-semibold">
                    &larr; Back to All Learning Guides
                </Link>
            </div>
        </div>
    );
}